import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type RecordSearchBase from "@/components/RecordSearch.Base.vue";

export default defineMosaicComponent<typeof RecordSearchBase>("components/RecordSearch");
